import { Position } from "@blueprintjs/core"
import React from "react"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import { useSearchFilter } from "hooks/searchFilterHooks"
const TableActionsButton = props => {
  const [{ type }, setFilter] = useSearchFilter()

  function handleClick(type) {
    switch (type) {
      case "sellable-item":
        setFilter(prev => ({
          ...prev,
          type: "sellable-item",
        }))
        return
      case "rpg":
        setFilter(prev => ({
          ...prev,
          type: "rpg",
        }))

        return
      case "raw-material":
        setFilter(prev => ({
          ...prev,
          type: "raw-material",
        }))

        return
      default:
        return
    }
  }

  return (
    <>
      <ActionMenu
        onClick={handleClick}
        popoverProps={{
          position: Position.BOTTOM_RIGHT,
        }}
        text={
          type === "rpg"
            ? "RPG"
            : type === "raw-material"
            ? "Raw material"
            : "Sellable item"
        }
        icon={null}
        rightIcon="caret-down"
        dark={true}
        {...props}
      >
        <ActionMenuItem text="Sellable item" id="sellable-item" />
        <ActionMenuItem text="RPG" id="rpg" />
        <ActionMenuItem text="Raw material" id="raw-material" />
      </ActionMenu>
    </>
  )
}

export default TableActionsButton
